import {
  SiReact, SiTypescript, SiTailwindcss, SiRedux,
  SiFlutter, SiSwift, SiKotlin,
  SiNodedotjs, SiGraphql, SiPostgresql, SiMongodb,
  SiDocker, SiKubernetes, SiAmazonaws, SiGithubactions,
} from 'react-icons/si'

const categories = [
  {
    title: 'Frontend',
    skills: [
      { name: 'React / Next.js', icon: SiReact, level: 96 },
      { name: 'TypeScript', icon: SiTypescript, level: 92 },
      { name: 'Redux / Zustand', icon: SiRedux, level: 88 },
      { name: 'Tailwind CSS', icon: SiTailwindcss, level: 94 },
    ],
  },
  {
    title: 'Mobile',
    skills: [
      { name: 'React Native', icon: SiReact, level: 90 },
      { name: 'Flutter', icon: SiFlutter, level: 82 },
      { name: 'Swift (iOS)', icon: SiSwift, level: 70 },
      { name: 'Kotlin (Android)', icon: SiKotlin, level: 68 },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Node.js', icon: SiNodedotjs, level: 95 },
      { name: 'GraphQL / REST', icon: SiGraphql, level: 89 },
      { name: 'PostgreSQL', icon: SiPostgresql, level: 87 },
      { name: 'MongoDB / Redis', icon: SiMongodb, level: 85 },
    ],
  },
  {
    title: 'Cloud & DevOps',
    skills: [
      { name: 'AWS', icon: SiAmazonaws, level: 84 },
      { name: 'Docker', icon: SiDocker, level: 88 },
      { name: 'Kubernetes', icon: SiKubernetes, level: 75 },
      { name: 'CI/CD (GitHub Actions)', icon: SiGithubactions, level: 86 },
    ],
  },
]

const Experience = () => {
  return (
    <section id='experience'>
      <h5>9+ years of building products</h5>
      <h2>My Experience</h2>

      <div className='container grid grid-cols-2 gap-8 max-[1024px]:grid-cols-1'>
        {categories.map(({ title, skills }) => (
          <div
            key={title}
            className='bg-bg-variant p-10 rounded-[2rem] border border-transparent transition hover:bg-transparent hover:border-primary-variant max-[1024px]:w-4/5 max-[1024px]:p-8 max-[1024px]:mx-auto max-[600px]:w-full max-[600px]:p-6'
          >
            <h3 className='text-center mb-8 text-primary'>{title}</h3>
            <div className='flex flex-col gap-6'>
              {skills.map(({ name, icon: Icon, level }) => (
                <article key={name}>
                  <div className='flex items-center gap-3 mb-2'>
                    <Icon className='text-primary text-lg shrink-0' />
                    <h4 className='text-[0.95rem] flex-1'>{name}</h4>
                    <small className='text-light text-[0.75rem]'>{level}%</small>
                  </div>
                  <div className='h-1.5 w-full rounded-full bg-white/10 overflow-hidden'>
                    <div
                      className='h-full rounded-full bg-primary'
                      style={{ width: `${level}%` }}
                    />
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Experience
